import { appGetItemFromId } from '../../selectors';
import withReduxData from '../../hoc/withReduxData';
import Work from '../../components/WorkPage';

/*const mapStateToProps = (state, props) => {
  const appGetItem = appGetItemFromId(state, props);
  return {
    item: appGetItem(state),
    path: props.match.url
  };
};*/

const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    const appGetItem = appGetItemFromId(props);
    return {
      item: appGetItem(state, props)
    };
  };
  return mapStateToProps;
};

export default withReduxData(makeMapStateToProps)(Work);



// WEBPACK FOOTER //
// ./src/containers/WorkContainer/index.js